import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse
} from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { CryptoUtilService } from 'src/app/services/crypto-util.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private crypto: CryptoUtilService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token');
    let modifiedReq = req;

    // Agregar Authorization header si hay token
    if (token) {
      modifiedReq = modifiedReq.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    // Encriptar cuerpo si es POST
    if (modifiedReq.method === 'POST') {
      const encryptedBody = { encript: this.crypto.encrypt(modifiedReq.body) };
      console.log('Cuerpo: ', modifiedReq.body)
      modifiedReq = modifiedReq.clone({ body: encryptedBody });
    }

    // Manejar la respuesta desencriptando si es necesario
    return next.handle(modifiedReq).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && event.body) {
          let decryptedBody
          if (event.body.statusCode == 200) {
            decryptedBody = this.crypto.decrypt(event.body.body);
          } else {
            decryptedBody = this.crypto.decrypt(event.body);
          }
          return event.clone({ body: decryptedBody });
        }
        return event;
      })
    );
  }
}




// import { Injectable } from '@angular/core';
// import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
// import { Observable } from 'rxjs';

// @Injectable()
// export class AuthInterceptor implements HttpInterceptor {
//   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     const token = localStorage.getItem('token'); // Obtiene el token del LocalStorage
//     let modifiedReq = req;

//     if (token) {
//       modifiedReq = req.clone({
//         setHeaders: {
//           Authorization: `Bearer ${token}`
//         }
//       });
//     }

//     return next.handle(modifiedReq);
//   }
// }